import React, { use, useEffect, useState } from "react";
import { Topbar } from "../../components/include/Topbar";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { message } from "../../redux/actions/toastActions";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
 import camera from "../../assets/camera.svg"


const Add_Member = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const [formData, setFormData] = useState({
    memberName: "",
    designation: "",
    bio: "",
    description: "",
    startDate: "",
    endDate: "",
    socialLinks: [],
    profilePicture: null,
  });
  const [apiloader, setapiloader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [linkInput, setLinkInput] = useState("");
  const [errors, setErrors] = useState({});
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [socialLinks, setSocialLinks] = useState([]);
  const [newLink, setNewLink] = useState("");
  const [previewURL, setPreviewURL] = useState(null);
  const [file, setFile] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  async function fetchData(id) {
    const response = await Postdata(HttpService.school_management_show, { id });

    if (response.status !== 200) {
      navigate("/school-management");
      return;
    }

    const data = response.data;

    setFormData({
      memberName: data.name || "",
      designation: data.designation || "",
      bio: data.bio || "",
      description: data.description || "",
      startDate: data.start_date ? data.start_date.split("T")[0] : "",
      endDate: data.end_date ? data.end_date.split("T")[0] : "",
      socialLinks: data.social_media || [],
      id: params.id,
    });

    setPreviewURL(data.profile_img || null); // to show existing image preview
    setapiloader(false);
  }

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Allowed formats
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      dispatch(message("Only JPG, JPEG, PNG, or WEBP formats are allowed"));
      return;
    }

    // Size check (10MB)
    if (file.size > 10 * 1024 * 1024) {
      dispatch(message("Image size must be less than 10MB"));
      return;
    }

    setFile(true);
    setFormData((prev) => ({ ...prev, profilePicture: file }));
    setPreviewURL(URL.createObjectURL(file));
  };

  const handleAddLink = () => {
    if (linkInput.trim() === "") return;
    setFormData({
      ...formData,
      socialLinks: [...formData.socialLinks, linkInput],
    });
    setLinkInput("");
  };

  const handleRemoveLink = (index) => {
    const newLinks = formData.socialLinks.filter((_, i) => i !== index);
    setFormData({ ...formData, socialLinks: newLinks });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.memberName) newErrors.memberName = true;
    if (!formData.designation) newErrors.designation = true;
    if (!formData.bio) newErrors.bio = true;
    if (!formData.description) newErrors.description = true;
    if (!formData.startDate) newErrors.startDate = true;
    // if (!formData.endDate) newErrors.endDate = true;
    // if (!formData.profilePicture) newErrors.profilePicture = true;
    if (formData.socialLinks.length === 0) newErrors.socialLinks = true;
    // Image required check
    if (!params.id && !formData.profilePicture) {
      newErrors.profilePicture = true; // Adding new, must have image
    }
    if (params.id && !formData.profilePicture && !previewURL) {
      newErrors.profilePicture = true; // Editing but no existing image
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    setLoader(true);

    const form = new FormData();
    if (params.id) form.append("id", formData.id);
    form.append("name", formData.memberName);
    form.append("designation", formData.designation);
    form.append("bio", formData.bio);
    form.append("description", formData.description);
    form.append("start_date", formData.startDate);
    form.append("end_date", formData.endDate);
    if (file) form.append("profile_img", formData.profilePicture); // binary file
    formData.socialLinks.forEach((link, i) =>
      form.append(`social_media[${i}]`, link)
    );

    Postdata(HttpService.school_management_add, form).then((res) => {
      if (res.status === 200) {
        navigate("/school-management");
      }
      dispatch(message(res.message));
    });
    setLoader(false);
    console.log("Submitted as FormData:", formData);
  };

  useEffect(() => {
    if (params.id) {
      setapiloader(true);
      fetchData(params.id);
    }
  }, []);

  console.log(location.state?.type, "++++++++++++");

  return (
    <>
      <Topbar
        title={
          location.state?.type === "edit"
            ? "Edit School Management"
            : "Add School Management"
        }
        aerrow={true}
      />
      <div className="max-w-6xl  mx-auto bg-gray-100 p-6 rounded-xl space-y-6">
        {/* Profile Picture */}
        <div className="flex flex-col items-center">
          <label className="flex flex-col items-center justify-center w-24 h-24 rounded-full border-2 border-purple-500 cursor-pointer overflow-hidden">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              className="hidden"
            />
            {previewURL ? (
              <img
                src={previewURL}
                alt="Preview"
                className="w-full h-full object-cover rounded-full"
              />
            ) : (
                  <img src={camera} alt="Camera Icon" className=" " />
            )}
          </label>
          <span className="text-sm mt-2 text-gray-700 font-medium">
            Upload Profile Picture <span className="text-red-500">*</span>
          </span>
          {errors.profilePicture && (
            <span className="text-red-500 text-sm">Profile picture is required</span>
          )}
        </div>

        {/* Inputs */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Member Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="memberName"
              placeholder="Enter Member Name"
              className="input-field"
              value={formData.memberName}
              onChange={handleInputChange}
            />
            {errors.memberName && (
              <span className="text-red-500 text-sm">Required</span>
            )}
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Designation <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="designation"
              placeholder="Enter Designation"
              className="input-field"
              value={formData.designation}
              onChange={handleInputChange}
            />
            {errors.designation && (
              <span className="text-red-500 text-sm">Required</span>
            )}
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Bio <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="bio"
              placeholder="Write Bio"
              className="input-field"
              value={formData.bio}
              onChange={handleInputChange}
            />
            {errors.bio && (
              <span className="text-red-500 text-sm">Required</span>
            )}
          </div>
        </div>

        {/* Description */}
        <div>
          <label className="block mb-1 font-medium text-gray-700">
            Description <span className="text-red-500">*</span>
          </label>
          <textarea
            name="description"
            placeholder="Write here"
            className="input-field"
            value={formData.description}
            onChange={handleInputChange}
          />
          {errors.description && (
            <span className="text-red-500 text-sm">Required</span>
          )}
        </div>

        {/* Social Media Links */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <div className="relative">
            <label className="block mb-1 font-medium text-gray-700">
              Social Media Links <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Social Media Link"
              className="input-field"
              value={linkInput}
              onChange={(e) => setLinkInput(e.target.value)}
            />
            <button
              type="button"
              onClick={handleAddLink}
              className="text-orange-600 font-medium absolute right-3 top-[50px]"
            >
              Add
            </button>
              {errors.socialLinks && (
              <span className="text-red-500 text-sm">Required</span>
            )}

            <div className="mt-2 space-y-1">
              {formData.socialLinks.map((link, index) => (
                <div key={index} className="flex items-center justify-between">
                  <a
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 underline text-sm"
                  >
                    {link}
                  </a>
                  <button
                    onClick={() => handleRemoveLink(index)}
                    className="text-red-600 text-sm"
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
            {/* {errors.memberName && (
              <span className="text-red-500 text-sm">Required</span>
            )} */}
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Start Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              name="startDate"
              className="input-field"
              value={formData.startDate}
              onChange={handleInputChange}
            />
            {errors.startDate && (
              <span className="text-red-500 text-sm">Required</span>
            )}
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">
              End Date 
            </label>
            <input
              type="date"
              name="endDate"
              className="input-field"
              value={formData.endDate}
              onChange={handleInputChange}
              min={formData.startDate || new Date().toISOString().split("T")[0]} 
            />
            {/* {errors.endDate && (
              <span className="text-red-500 text-sm">Required</span>
            )} */}
          </div>
        </div>

        {/* Submit Button */}
        <div className="text-center">
          <button
            onClick={handleSubmit}
            className="bg-primary_main text-white px-16 py-2 rounded-lg font-medium hover:bg-purple-700"
          >
            {loader
              ? "Please wait..."
              : formData.id
                ? "Edit Member"
                : "Add Member"}
          </button>
        </div>
      </div>
    </>
  );
};

export default Add_Member;
